import Tooltip from './Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

const LabelWithTooltip = ({ text = 'Время отправки показаний (UTC)', tooltipText = 'Московское время = UTC +3 часа', tooltipImage }) => {
  return (
    <span className={'flex gap-x-1 items-center'}>
      {text}
      <Tooltip text={tooltipText} color={'text-dark-500'} image={tooltipImage}>
        <InfoOutlinedIcon fontSize="small" className={'text-orange-500'} />
      </Tooltip>
    </span>
  );
};

export default LabelWithTooltip;
